import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

/**
 * This mapper created so Lean's generated mapper won't override the results coming from the mapper in TB.
 */
const props = withCompInfo<any, any, any>()([], (_, carmiData) => {
  return {
    ...carmiData,
  };
});

export default createComponentMapperModel({ props });
